import { render, staticRenderFns } from "./sychzb.vue?vue&type=template&id=df8dd5e0&scoped=true&"
import script from "./sychzb.vue?vue&type=script&lang=js&"
export * from "./sychzb.vue?vue&type=script&lang=js&"
import style0 from "./sychzb.vue?vue&type=style&index=0&id=df8dd5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df8dd5e0",
  null
  
)

export default component.exports